export enum StepOneFormKeys {
  selfPayor = 'selfPayor',
  newPatient = 'newPatient',
  appointmentType = 'appointmentType',
  reasonForVisit = 'reasonForVisit',
  timeslotHold = 'timeslotHold',
}

export const SELECT_OPTION_VALUE = 'select';

export const STEP_ONE_DEFAULT_VALUES = {
  [StepOneFormKeys.selfPayor]: '0',
  [StepOneFormKeys.newPatient]: '',
  [StepOneFormKeys.appointmentType]: '',
  [StepOneFormKeys.reasonForVisit]: '',
  [StepOneFormKeys.timeslotHold]: '',
};

export const REASON_FOR_VISIT_REGEX = /^[A-Za-z0-9'?,.&\-\s]+$/;
export const MAX_CHARACTERS_REASON_FOR_VISIT = 250;
export const TELEHEALTH_APPOINTMENT_TYPE_ID = '972';

export const TELEHEALTH_MODAL = 'TELEHEALTH_MODAL';
export const TIME_REMAINING_MODAL = 'TIME_REMAINING_MODAL';
export const TIME_RELEASED_MODAL = 'TIME_RELEASED_MODAL';
export const TIME_UNAVAILABLE_MODAL = 'TIME_UNAVAILABLE_MODAL';
export const TIME_NOT_BOOKED_ERROR_MODAL = 'TIME_NOT_BOOKED_ERROR_MODAL';
export const HOLD_API_DATE_TIME_FORMAT = 'yyyyMMddHH:mm';
export const HOLD_API_DATE_FORMAT = 'yyyyMMdd';
export const HOLD_API_START_TIME_FORMAT = 'HH:mm';
export const BOOKING_API_DATE_TIME_FORMAT = "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'";
export const NEUTRON_DATEPICKER_FORMAT = 'yyyy-MM-dd';
export const FIRST_AVAILABLE_DAY_FORMAT_TOKEN = 'EEEE, LLLL dd';
export const NUMBER_DAYS_OUT = '61'; // API returns 62 items in total .... don't ask me
export const HOLD_REMAINING_TIMEOUT = 1000 * 60 * 10; // 10 mits
export const SLOT_RELEASED_TIMEOUT = 1000 * 60 * 5; // 5 mins
export const SCROLL_TIMEOUT = 100;
export const CHUNK_SIZE = 5;

export const SELF_PAYOR_YES_NO_OPTIONS = [
  { label: 'Yes', value: '1' },
  { label: 'No', value: '0' },
];

export const NEW_PATIENT_YES_NO_OPTIONS = [
  { label: 'Yes', value: '0' },
  { label: 'No', value: '1' },
];
